import React, { useCallback } from 'react';
import { CollectionServer, FilterToQueryParameters, JSXMap, QueryOrder, QueryParametersToFilters, useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSearchParams } from 'react-router-dom';
import EventListItem from '../../../../components/EventListItem';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../../common/Context';
import PageLayout from '../../../../components/PageLayout';

dayjs.locale('ru');
var _ = require('lodash');

export default function PromouterEvents(props) {
    const sourceKey = "promouter";
    const auth = useAuth();
    let [searchParams, setSearchParams] = useSearchParams();
    const onChangeRequestParameters = (value) => {
        if (value) {
            setSearchParams(value)
        }
    }

    const filters = React.useCallback(() => QueryParametersToFilters(searchParams, [
        {
            label: "Дата начала",
            name: "nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,

            sorted: "ASC",
        },
        {
            label: "Дата окончания",
            name: "okonchanieSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
            filtered: [dayjs(), dayjs().add(1, "years")],
        },
        {   // Тип мероприятия
            label: "Тип мероприятия",
            name: "tipMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Уровень мероприятия
            label: "Уровень мероприятия",
            name: "urovenMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Место проведения
            label: "Место проведения",
            name: "mestoProvedeniya",
            filterType: "group",
            display: (o) => o.name,
            sort: true,
            filter: true
        },
        // {   
        //     label: "Региональное отделение",
        //     name: "organizatorRegionalnoeOtdelenie",
        //     source: "/papi/fed/ro/list",
        //     filterType: "group",
        //     display: (o) => o.nazvanie,
        //     queryFilter: [
        //         QueryOrder("nazvanie", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true
        // },
        // {   
        //     label: "Организатор",
        //     name: "organizatorMeropriyatiya",
        //     source: "/papi/fed/org/list",
        //     filterType: "group",
        //     display: (o) => o.nazvanie,
        //     queryFilter: [
        //         QueryOrder("nazvanie", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true
        // },
        // {   
        //     label: "Школа",
        //     name: "organizatorShkola",
        //     source: "/papi/fed/school/list",
        //     filterType: "group",
        //     display: (o) => o.nazvanieShkoliTantsev,
        //     queryFilter: [
        //         QueryOrder("nazvanieShkoliTantsev", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true
        // },
        {
            label: "Категория",
            type: "object",
            relation: {
                reference: {
                    object: "KategoriiUchastnikov",
                    queryFilter: [
                        QueryOrder("opisanie", "ASC"),
                    ],
                }
            },
            name: "kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie.kategoriyaUchastnikov",
            filterType: "group",
            display: (o) => o.opisanie,
            // sort: true,
            filter: true
        }
    ]), [searchParams]);
    const ConvertFilterToQueryParameters = useCallback((value) => {
        if (onChangeRequestParameters) {
            onChangeRequestParameters(FilterToQueryParameters(filters(), value.filter, value.sorting, value.page, value.count))
        }
    }, [onChangeRequestParameters])
    const QueryParametersToPage = useCallback(() => {
        if (searchParams)
            return searchParams.get("page") || 1;
    }, [searchParams]);
    const QueryParametersToPageCount = useCallback(() => {
        if (searchParams)
            return searchParams.get("count") || 15;
    }, [searchParams]);

    const FilterFromContextFilter = React.useCallback(() => [
        // QueryParam("w-nu-OrganizatorFederatsiya", 0),
        // If((dance && dance.length > 0), QueryParam("w-in-KategoriiUchastnikovNaMeropriyatiyakhMeropriyatie.TantsevalnayaDistsiplina.VidTantsa.Tanets", dance?.join(","))),
    ], []);

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    return (
        <PageLayout hideSider={true}>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <CollectionServer
                        auth={auth}
                        name={"Meropriyatiya"}
                        source={`/api/meropriyatiya/list/${sourceKey}`}
                        contextFilters={FilterFromContextFilter}
                        filters={filters}
                        onChangeRequestParameters={ConvertFilterToQueryParameters}
                        page={QueryParametersToPage}
                        count={QueryParametersToPageCount}
                        size={"small"}

                        customRender={(items, {
                            collection,
                            setCollection,
                            setCollectionItem,
                            removeCollectionItem,
                            collectionActions,
                            modelActions,
                            update
                        }) => (<div>
                            {JSXMap(items, (item, idx) => {
                                return (<EventListItem
                                    key={idx}
                                    event={item}
                                    // qr={item.Data}
                                    // tickets={ticket()}
                                    // adminButton={() => `event-admin/${item.ID}`}
                                    // adminButton={true}
                                    extButtons={({path, size, style}) => [
                                        <div key="view">
                                            <a
                                                style={style}
                                                className={`btn btn-soft-secondary btn-sm`}
                                                href={`${path(1)}/${item.ID}`}
                                            >
                                                Просмотр
                                            </a>
                                        </div>
                                    ]}
                                    size={(idx === 0) ? "large" : "medium"}
                                />)
                            })}
                        </div>)}
                    />
                </div>
            </div>
        </PageLayout>
    );
}
